<template>
  <div v-if="detail != ''" class="container">
    <ul>
      <li>
        <label>调拨单号：</label>
        <p>{{ detail.allocation_number }}</p>
      </li>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>调货网点：</label>
        <p>{{ detail.device_name }}</p>
      </li>
      <li>
        <label>调货员工：</label>
        <p>{{ detail.user_name }}</p>
      </li>
      <li>
        <label>收货网点：</label>
        <p>{{ detail.collect_device_name }}</p>
      </li>
      <li>
        <label>收货员工：</label>
        <p>{{ detail.collect_user_name }}</p>
      </li>
      <li>
        <label>调拨时间：</label>
        <p>{{ detail.allocation_time }}</p>
      </li>
      <li>
        <label>调拨单创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>调拨单修改时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p v-show="detail.status == 1">待收货</p>
        <p v-show="detail.status == 2">无差异入库</p>
        <p v-show="detail.status == 3">待管理介入</p>
        <p v-show="detail.status == 4">管理通过</p>
        <p v-show="detail.status == 5">管理驳回</p>
      </li>
      <li v-show="detail.status == 3">
        <label>差异原因：</label>
        <p>{{ detail.reason }}</p>
      </li>
      <li v-show="detail.status == 5">
        <label>驳回原因：</label>
        <p>{{ detail.rejectreason }}</p>
      </li>
      <li v-show="detail.status == 5 || detail.status == 4">
        <label>审核人：</label>
        <p>{{ detail.check_user_name }}</p>
      </li>
      <!-- <li v-show="detail.status == 5 || detail.status == 4">
        <label>审核时间：</label>
        <p>{{ detail.check_time }}</p>
      </li> -->
    </ul>
    <table>
      <thead>
        <th>商品名称</th>
        <th>商品图</th>
        <th>调拨数量</th>
        <th>收货数量</th>
        <th>差异</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in detail.material_list" :key="index">
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>{{ item.num }}</td>
          <td>{{ item.confirm_num }}</td>
          <td>
            {{ Number(item.confirm_num) - Number(item.num) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="operation" v-show="detail.status == 3">
      <a-button type="primary" @click="auditPagePass">
        调拨通过
      </a-button>
      <a-button type="danger" @click="auditPageReject">
        调拨驳回
      </a-button>
    </div>
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <label><i>*</i>驳回原因：</label>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectIsShow = false">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      rejectIsShow: false,
      reason: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      console.log(this.detail.material_list);
    },
    auditPagePass() {
      let _this = this;
      this.$confirm({
        title: "审核调拨",
        content: "一旦确定，双方库存进行自动校正，是否确认操作!",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.orderPassOperation();
        },
        onCancel() {}
      });
    },
    orderPassOperation() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_material_allocation/adoptDifference";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.detail.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("审核成功");
          } else {
            this.$message.info(res.data.message);
          }
          this.$emit("hideIsDetail", true);
        })
        .catch(err => {});
    },
    auditPageReject() {
      this.rejectIsShow = true;
    },
    rejectSure() {
      if (this.reason != "" && this.reason != null) {
        this.rejectIsShow = false;
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Device_material_allocation/reject";
        axios
          .post(url, {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.detail.id,
            rejectreason: this.reason
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("已驳回");
              this.$emit("hideIsDetail", true);
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      } else {
        this.$message.info("请填写驳回原因");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  position: relative;
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  .operation {
    position: absolute;
    right: 30px;
    top: 20px;
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
}
</style>
